import { render, staticRenderFns } from "./RankItem.vue?vue&type=template&id=65e3ebbd&scoped=true"
import script from "./RankItem.vue?vue&type=script&lang=js"
export * from "./RankItem.vue?vue&type=script&lang=js"
import style0 from "./RankItem.vue?vue&type=style&index=0&id=65e3ebbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e3ebbd",
  null
  
)

export default component.exports